const CardHeader = ({ children = <></>, className = '', style = {} }) => {
    return (
        <div
            className={`card-header d-flex align-items-center justify-content-between px-4 py-3 ${className}`}
            style={{
                backgroundColor: '#FFFFFF',
                borderBottom: '1px solid #F1F5F9',
                minHeight: '48px',
                fontWeight: 600,
                color: '#0F172A',
                ...style,
            }}
        >
            {children}
        </div>
    );
}

export default CardHeader;